<template>
  <div class="in-product-detail">
    <main v-if="disabled" class="main container product-details-main">
      <Skeleton class="skeleton-Path mt-4">
        <Skeleton class="skeleton-Path-item bg-skeleton-item"></Skeleton>
        <Skeleton class="skeleton-Path-item bg-skeleton-item"></Skeleton>
        <Skeleton class="skeleton-Path-item bg-skeleton-item"></Skeleton>
      </Skeleton>
      <Skeleton class="skeleton-top-content mt-4">
        <div class="top">
          <Skeleton
            class="skeleton-item bg-skeleton-item"
            style="width: 150px"
          ></Skeleton>
          <Skeleton
            class="skeleton-item bg-skeleton-item"
            style="width: 200px"
          ></Skeleton>
          <Skeleton
            class="skeleton-item bg-skeleton-item"
            style="width: 300px"
          ></Skeleton>
          <div>
            <Skeleton class="skeleton-item bg-skeleton-item"></Skeleton>
            <Skeleton class="skeleton-item bg-skeleton-item"></Skeleton>
            <Skeleton class="skeleton-item bg-skeleton-item"></Skeleton>
            <Skeleton class="skeleton-item bg-skeleton-item"></Skeleton>
          </div>
        </div>
        <Skeleton class="skeleton-center-item bg-skeleton-item"></Skeleton>
        <div class="down">
          <div>
            <Skeleton class="skeleton-item bg-skeleton-item"> </Skeleton>
            <Skeleton class="skeleton-item bg-skeleton-item"></Skeleton>
          </div>
          <Skeleton class="skeleton-item bg-skeleton-item"></Skeleton>
          <Skeleton class="skeleton-item bg-skeleton-item"></Skeleton>
        </div>
      </Skeleton>

      <Skeleton class="skeleton-Specifications"> </Skeleton>
      <Skeleton class="skeleton-Review">
        <Skeleton class="skeleton-item bg-skeleton-item"></Skeleton>
        <Skeleton class="skeleton-item bg-skeleton-item"></Skeleton>
        <Skeleton class="skeleton-item bg-skeleton-item"></Skeleton>
        <Skeleton class="skeleton-item bg-skeleton-item"></Skeleton>
      </Skeleton>
    </main>

    <main class="main container product-details-main mt-2 mt-lg-4" v-else>
      <PagesPath
        class="mb-4 breadcrumb-des"
        :pathTitle1="
          product != null && product.categories && product.categories.length
            ? product.categories[0].title
            : 'محصولات'
        "
        :pathTo1="
          product != null && product.categories && product.categories.length
            ? `/products/category/${product.categories[0].pivot.category_id}`
            : '/products'
        "
        :pathTitle2="product != null ? product.title : ''"
      ></PagesPath>
      <div class="white-bg">
        <PagesPath
          class="mb-2 breadcrumb-mobile"
          :pathTitle1="
            product != null && product.categories && product.categories.length
              ? product.categories[0].title
              : 'محصولات'
          "
          :pathTo1="
            product != null && product.categories && product.categories.length
              ? `/products/category/${product.categories[0].pivot.category_id}`
              : '/products'
          "
          :pathTitle2="product != null ? product.title : ''"
        ></PagesPath>
        <!-- :path="product != null ? product.categories : ''" -->
        <ProductContent
          v-if="product && !product.isPreview"
          class="mt-2 mt-lg-4"
          :comparable="true"
          v-model="product"
        />
      </div>
      <SimilarProducts
        v-if="product && !product.isPreview"
        :related="relatedProducts"
      />
      <section class="product-specifications-comments">
        <div v-if="product != null && !product.isPreview" class="tab-content">
          <div
            class="white-bg mt-4"
            id="productSpecifications"
            v-if="product != null && product.specifications != ''"
          >
            <ul
              class="nav nav-tabs border-bottom padding-t-15 padding-b-15 gap-10"
            >
              <li>
                <a
                  class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small active"
                  @click="scrollToTab('productSpecifications')"
                  >مشخصات</a
                >
              </li>
              <li v-if="product != null && product.description != null">
                <a
                  class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small"
                  @click="scrollToTab('productReview')"
                  >نقد و بررسی</a
                >
              </li>

              <li>
                <a
                  class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small"
                  @click="scrollToTab('productComments')"
                  >نظرات کاربران</a
                >
              </li>
              <li>
                <a
                  class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small"
                  @click="scrollToTab('productQuestion')"
                  >پرسش و پاسخ</a
                >
              </li>
            </ul>
            <ProductSpecifications
              class="mt-4"
              :activeTab="'specifications'"
              :product="product"
            />
          </div>
          <div
            class="white-bg mt-4"
            id="productReview"
            v-if="product != null && product.description != null"
          >
            <ul
              class="nav nav-tabs border-bottom padding-t-15 padding-b-15 gap-10"
            >
              <li v-if="product != null && product.specifications != ''">
                <a
                  class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small"
                  @click="scrollToTab('productSpecifications')"
                  >مشخصات</a
                >
              </li>
              <li>
                <a
                  class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small active"
                  @click="scrollToTab('productReview')"
                  >نقد و بررسی</a
                >
              </li>
              <li>
                <a
                  class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small"
                  @click="scrollToTab('productComments')"
                  >نظرات کاربران</a
                >
              </li>
              <li>
                <a
                  class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small"
                  @click="scrollToTab('productQuestion')"
                  >پرسش و پاسخ</a
                >
              </li>
            </ul>
            <ProductReview :activeTab="'review'" :product="product" />
          </div>

          <div class="white-bg mt-4" id="productComments">
            <ul
              class="nav nav-tabs border-bottom padding-t-15 padding-b-15 gap-10"
            >
              <li v-if="product != null && product.specifications != ''">
                <a
                  class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small"
                  @click="scrollToTab('productSpecifications')"
                  >مشخصات</a
                >
              </li>
              <li v-if="product != null && product.description != null">
                <a
                  class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small"
                  @click="scrollToTab('productReview')"
                  >نقد و بررسی</a
                >
              </li>
              <li>
                <a
                  class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small active"
                  @click="scrollToTab('productComments')"
                  >نظرات کاربران</a
                >
              </li>
              <li>
                <a
                  class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small"
                  @click="scrollToTab('productQuestion')"
                  >پرسش و پاسخ</a
                >
              </li>
            </ul>
            <ProductComments :activeTab="'comments'" :product="product" />
          </div>
          <div class="white-bg mt-4" id="productQuestion">
            <ul
              class="nav nav-tabs border-bottom padding-t-15 padding-b-15 gap-10"
            >
              <li v-if="product != null && product.specifications != ''">
                <a
                  class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small"
                  @click="scrollToTab('productSpecifications')"
                  >مشخصات</a
                >
              </li>
              <li v-if="product != null && product.description != null">
                <a
                  class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small"
                  @click="scrollToTab('productReview')"
                  >نقد و بررسی</a
                >
              </li>

              <li>
                <a
                  class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small"
                  @click="scrollToTab('productComments')"
                  >نظرات کاربران</a
                >
              </li>
              <li>
                <a
                  class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small active"
                  @click="scrollToTab('productQuestion')"
                  >پرسش و پاسخ</a
                >
              </li>
            </ul>
            <ProductQuestion
              :activeTab="'productQuestion'"
              :product="product"
            />
          </div>
        </div>
        <div v-else class="tab-content mt-5">
          <div id="review" class="tab-pane fade in active show">
            <p class="fontsize14 text-color-666 text-justify line-height2 p-3">
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="85%"></b-skeleton>
            </p>
          </div>
        </div>
      </section>
      <ScrollToTop></ScrollToTop>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import PagesPath from "@/parts/Front/components/PagesPath";
import ScrollToTop from "@/parts/Front/components/ScrollToTop";
import ProductServices from "@/parts/Front/components/productDetail/ProductServices";
import ProductComments from "@/parts/Front/components/productDetail/ProductComments";
import ProductQuestion from "@/parts/Front/components/productDetail/ProductQuestion";
import ProductSpecifications from "@/parts/Front/components/productDetail/ProductSpecifications";
import ProductReview from "@/parts/Front/components/productDetail/ProductReview";
import SimilarProducts from "@/parts/Front/components/productDetail/SimilarProducts";
import ProductContent from "@/parts/Front/components/productDetail/ProductContent";
import product from "@/parts/Front/components/productDetail/classes/product";
import ProductCongratulations from "@/parts/Front/components/productDetail/ProductCongratulations";
import config from "@/config";
import { BSkeleton } from "bootstrap-vue";

export default {
  name: "ProductDetails",
  components: {
    ProductCongratulations,
    PagesPath,
    ScrollToTop,
    ProductServices,
    ProductComments,
    ProductQuestion,
    ProductSpecifications,
    ProductReview,
    SimilarProducts,
    ProductContent,
    BSkeleton,
  },
  data() {
    return {
      url: "front/products/",
      title: "",
      disabled: false,
      relatedProducts: Array(5).fill(null),
      product: null,
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.getProduct(this.$route.params.id);
    }
    this.onResize();
    window.removeEventListener("resize", this.onResize);
    window.addEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      const bodyWidth = document.body.offsetWidth;
      const colorChooseImg = document.querySelectorAll(".color-choose-img")[0];
      // const productDetContent=document.querySelectorAll('.product-details-content')[0];
      if (colorChooseImg) {
        if (bodyWidth < 767) {
          colorChooseImg.style.width = bodyWidth - 100 + "px";
        }
      }
    },
    // changeTab(name) {
    //   // this.$store.commit('front/setProductActiveTab', name)
    //   this.activeTab = name
    // },
    async getProduct(id) {
      this.disabled = true;
      try {
        if (this.getInitialProductInfo) {
          this.product = this.getInitialProductInfo;
        }
        const response = await this.$store.dispatch(
          "front/getProductFromServer",
          id
        );
        this.product = new product(response.data.data.product, this);
        this.relatedProducts = response.data.data.relatedProducts1;

        // if (this.product.description != null) {
        //   this.activeTab = 'review'
        // } else if (this.product.description == null && this.product.specifications != '') {
        //   this.activeTab = 'specifications'
        // } else {
        //   this.activeTab = 'comments'
        // }
      } catch (error) {
        this.$root.errorNotify("محصول مورد نظر یافت نشد");
        this.$router.push("/");
      } finally {
        this.disabled = false;
      }
    },
    scrollToTab(selectedTab) {
      const element = document.getElementById(selectedTab);
      if (element) {
        const yOffset = -50;
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    },
  },
  computed: {
    getInitialProductInfo() {
      return this.$store.getters["front/getSavedProductInfo"];
    },
  },
  metaInfo() {
    return {
      title: this.product
        ? `${this.product.title} ${config.title}`
        : config.title,
      meta: [
        {
          name: "description",
          content: this.product
            ? this.product.meta_description
              ? this.product.meta_description
              : this.product.short_description
            : false,
        },
        {
          property: "og:title",
          content: this.product ? this.product.title : false,
        },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
};
</script>

<style scoped>
.skeleton-Path {
  height: 50px;
  padding-right: 24px;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.skeleton-Path-item {
  height: 20px;
  width: 80px;
}
.skeleton-top-content {
  min-height: 831px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding-inline: 24px;
}
.skeleton-top-content .top {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.skeleton-top-content .top > .skeleton-item {
  height: 20px;
  width: 150px;
}
.skeleton-top-content .top > div {
  display: flex;
  gap: 10px;
}
.skeleton-top-content .top > div > .skeleton-item {
  height: 30px;
  width: 30px;
}
.skeleton-center-item {
  height: 496px;
}
.skeleton-top-content .down {
  display: flex;
  width: 100%;

  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 66px;
  margin-top: 1rem;
}
.skeleton-top-content .down .skeleton-item {
  width: 30%;
  height: 42px;
}
.skeleton-top-content .down > div {
  display: flex;
  gap: 30px;
  flex-grow: 1;
}
.skeleton-top-content .down > div .skeleton-item:first-child {
  width: 248px;
}
.skeleton-top-content .down > div .skeleton-item:nth-child(2) {
  width: 340px;
}
.skeleton-top-content .down .skeleton-item:last-child {
  width: 183px;
}
.skeleton-Specifications {
  height: 519px;
  margin-top: 36px;
}

.skeleton-Review {
  min-height: 1200px;
  margin-top: 36px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 1rem;
}
.skeleton-Review > .skeleton-item {
  height: 300px;
}
@media screen and (max-width: 1000px) {
  .skeleton-top-content .down > div {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
    width: 100%;
  }
  .skeleton-top-content .down {
    flex-direction: column;
    align-items: flex-start;
  }
}
@media screen and (max-width: 500px) {
  .skeleton-top-content .down > div .skeleton-item:first-child {
    width: 80%;
  }
  .skeleton-top-content .down > div .skeleton-item:nth-child(2) {
    width: 93%;
  }
  .skeleton-top-content .down .skeleton-item:last-child {
    width: 183px;
  }
  .skeleton-center-item {
    height: 400px;
  }
  .skeleton-Specifications {
    height: 589px;
  }
}
</style>
<style>
.product-details-main .breadcrumb-mobile.pages-path {
  display: none !important;
  margin-top: unset !important;
  padding: 0 !important;
}
div#isFree {
  background: #ff294f;
  color: white;
  padding: 4px 8px;
  border-radius: 15px;
  max-width: 100%;
  width: max-content;
  text-align: center;
  font-size: 14px;
  /* box-shadow: 0 0 5px #1213; */
}
@media screen and (max-width: 768px) {
  .product-details-main .breadcrumb-des.pages-path {
    display: none !important;
  }
  .product-details-main .breadcrumb-mobile.pages-path {
    display: block !important;
    margin-top: unset !important;
    padding: 0 !important;
    box-shadow: none;
  }
  .product-details-main .breadcrumb-mobile.pages-path .content-pagePath {
    box-shadow: none;
  }
  h2 {
    font-size: 1.6rem;
  }
  .product-details-main .content-pagePath {
    padding: 6px !important;
  }
  @media screen and (max-width: 500px) {
    .nav-tabs li a {
      font-size: 12px !important;
      padding: 0.25rem 8px !important;
      margin: 0.12rem !important;
    }
  }
  div#isFree {
    background: #ff294f;
    color: white;
    padding: 4px 8px;
    border-radius: 15px 0 0 15px;
    text-align: center;
    font-size: 12px;
    border-right: 2px solid black;
  }
}
@media (max-width: 1000px) {
  #goftino_w {
    bottom: 79px !important;
    right: 6px !important;
  }
  .scroll-to-top {
    bottom: 90px !important;
  }
}
@media (max-width: 750px) {
  .scroll-to-top {
    bottom: 40px !important;
  }
}
</style>
